RivalIQ.module('tracking', function (tracking, App, Backbone, Marionette, $, _, window) {

    'use strict';

    const TrackingObject = tracking.metric = {};

    TrackingObject.ChangePassword = {};
    TrackingObject.ChangePassword.name = 'Change Password';
    TrackingObject.ChangePassword.module = 'Main';

    // for v2
    TrackingObject.V2ViewedFollowing = {};
    TrackingObject.V2ViewedFollowing.name = 'V2ViewedFollowing';
    TrackingObject.V2ViewedFollowing.module = 'Following';

    TrackingObject.V2ViewedCompany = {};
    TrackingObject.V2ViewedCompany.name = 'V2ViewedCompany';
    TrackingObject.V2ViewedCompany.module = 'Company';


    TrackingObject.V2ClickedCompanyProfile = {};
    TrackingObject.V2ClickedCompanyProfile.name = 'V2ClickedCompanyProfile';
    TrackingObject.V2ClickedCompanyProfile.module = 'Company';

    TrackingObject.UsedExportInCompanyProfile = {};
    TrackingObject.UsedExportInCompanyProfile.name = 'Used_Export_In_Company_Profile';
    TrackingObject.UsedExportInCompanyProfile.module = 'Company';

    TrackingObject.ClickedCompanyPages = {};
    TrackingObject.ClickedCompanyPages.name = 'clicked_company_pages';
    TrackingObject.ClickedCompanyPages.module = 'Company';

    TrackingObject.V2ClickedCompanyFeed = {};
    TrackingObject.V2ClickedCompanyFeed.name = 'V2ClickedCompanyFeed';
    TrackingObject.V2ClickedCompanyFeed.module = 'Company';

    TrackingObject.V2ClickedCompanyCompare = {};
    TrackingObject.V2ClickedCompanyCompare.name = 'V2ClickedCompanyCompare';
    TrackingObject.V2ClickedCompanyCompare.module = 'Company';

    TrackingObject.ViewedFacebookGeographicData = {};
    TrackingObject.ViewedFacebookGeographicData.name = 'Viewed_Facebook_Geographic_Data';
    TrackingObject.ViewedFacebookGeographicData.module = 'Company';

    TrackingObject.V2ViewedAnalyze = {};
    TrackingObject.V2ViewedAnalyze.name = 'V2ViewedAnalyze';
    TrackingObject.V2ViewedAnalyze.module = 'Main';

    TrackingObject.UsedTitleDropdownNavigation = {};
    TrackingObject.UsedTitleDropdownNavigation.name = 'Used_Title_Dropdown_Navigation';
    TrackingObject.UsedTitleDropdownNavigation.module = 'Main';

    TrackingObject.V2ViewedLandingPage = {};
    TrackingObject.V2ViewedLandingPage.name = 'V2ViewedLandingPage';
    TrackingObject.V2ViewedLandingPage.module = 'Main';

    TrackingObject.V2ViewedBetaSignup = {};
    TrackingObject.V2ViewedBetaSignup.name = 'V2ViewedBetaSignup';
    TrackingObject.V2ViewedBetaSignup.module = 'Main';

    TrackingObject.V2DidBetaSignup = {};
    TrackingObject.V2DidBetaSignup.name = 'V2DidBetaSignup';
    TrackingObject.V2DidBetaSignup.module = 'Main';

    TrackingObject.V2ViewedDashboard = {};
    TrackingObject.V2ViewedDashboard.name = 'V2ViewedDashboard';
    TrackingObject.V2ViewedDashboard.module = 'Main';


    TrackingObject.V2AnalyzeDeepLinkQuickStats = {};
    TrackingObject.V2AnalyzeDeepLinkQuickStats.name = 'V2AnalyzeDeepLinkQuickStats';
    TrackingObject.V2AnalyzeDeepLinkQuickStats.module = 'Main';

    TrackingObject.V2AnalyzeDeepLinkAnalysesToTry = {};
    TrackingObject.V2AnalyzeDeepLinkAnalysesToTry.name = 'V2AnalyzeDeepLinkAnalysesToTry';
    TrackingObject.V2AnalyzeDeepLinkAnalysesToTry.module = 'Main';

    TrackingObject.V2AnalyzeDeepLinkEmail = {};
    TrackingObject.V2AnalyzeDeepLinkEmail.name = 'V2AnalyzeDeepLinkEmail';
    TrackingObject.V2AnalyzeDeepLinkEmail.module = 'Main';

    TrackingObject.V2DashboardReloadQuickStats = {};
    TrackingObject.V2DashboardReloadQuickStats.name = 'V2DashboardReloadQuickStats';
    TrackingObject.V2DashboardReloadQuickStats.module = 'Main';

    TrackingObject.V2DashboardReloadRecs = {};
    TrackingObject.V2DashboardReloadRecs.name = 'V2DashboardReloadRecs';
    TrackingObject.V2DashboardReloadRecs.module = 'Main';

    TrackingObject.V2DashboardReloadAnalysesToTry = {};
    TrackingObject.V2DashboardReloadAnalysesToTry.name = 'V2DashboardReloadAnalysesToTry';
    TrackingObject.V2DashboardReloadAnalysesToTry.module = 'Main';

    TrackingObject.V2UsedSite = {};
    TrackingObject.V2UsedSite.name = 'V2UsedSite';
    TrackingObject.V2UsedSite.module = 'Main';

    TrackingObject.V2ViewedShare = {};
    TrackingObject.V2ViewedShare.name = 'V2ViewedShare';
    TrackingObject.V2ViewedShare.module = 'Main';

    TrackingObject.V2CreateShareDashboard = {};
    TrackingObject.V2CreateShareDashboard.name = 'V2CreateShareDashboard';
    TrackingObject.V2CreateShareDashboard.module = 'Main';

    TrackingObject.V2CreateShareCompetitors = {};
    TrackingObject.V2CreateShareCompetitors.name = 'V2CreateShareCompetitors';
    TrackingObject.V2CreateShareCompetitors.module = 'Main';

    TrackingObject.V3SignedUp = {};
    TrackingObject.V3SignedUp.name = 'V3SignedUp';
    TrackingObject.V3SignedUp.module = 'Main';

    TrackingObject.V3ViewedSignup = {};
    TrackingObject.V3ViewedSignup.name = 'V3ViewedSignup';
    TrackingObject.V3ViewedSignup.module = 'Main';

    TrackingObject.V3SignupError = {};
    TrackingObject.V3SignupError.name = 'V3SignupError';
    TrackingObject.V3SignupError.module = 'Main';

    TrackingObject.ViewedIntercom = {};
    TrackingObject.ViewedIntercom.name = 'Viewed_Intercom';
    TrackingObject.ViewedIntercom.module = 'Main';

    TrackingObject.ClickedSecondaryNavItem = {};
    TrackingObject.ClickedSecondaryNavItem.name = 'Clicked_Secondary_Nav_Item';
    TrackingObject.ClickedSecondaryNavItem.module = 'Main';

    TrackingObject.V3RegistrationStarted = {};
    TrackingObject.V3RegistrationStarted.name = 'V3RegistrationStarted';
    TrackingObject.V3RegistrationStarted.module = 'Registration';

    TrackingObject.V3RegistrationViewedDetails = {};
    TrackingObject.V3RegistrationViewedDetails.name = 'V3RegistrationViewedDetails';
    TrackingObject.V3RegistrationViewedDetails.module = 'Registration';

    TrackingObject.V3RegistrationCompletedDetails = {};
    TrackingObject.V3RegistrationCompletedDetails.name = 'V3RegistrationCompletedDetails';
    TrackingObject.V3RegistrationCompletedDetails.module = 'Registration';

    TrackingObject.V3RegistrationViewedCompany = {};
    TrackingObject.V3RegistrationViewedCompany.name = 'V3RegistrationViewedCompany';
    TrackingObject.V3RegistrationViewedCompany.module = 'Registration';

    TrackingObject.V3RegistrationCompletedCompany = {};
    TrackingObject.V3RegistrationCompletedCompany.name = 'V3RegistrationCompletedCompany';
    TrackingObject.V3RegistrationCompletedCompany.module = 'Registration';

    TrackingObject.V3RegistrationViewedLandscape = {};
    TrackingObject.V3RegistrationViewedLandscape.name = 'V3RegistrationViewedLandscape';
    TrackingObject.V3RegistrationViewedLandscape.module = 'Registration';

    TrackingObject.V3RegistrationCompletedLandscape = {};
    TrackingObject.V3RegistrationCompletedLandscape.name = 'V3RegistrationCompletedLandscape';
    TrackingObject.V3RegistrationCompletedLandscape.module = 'Registration';

    TrackingObject.V3RegistrationAddedCompanyToLandscape = {};
    TrackingObject.V3RegistrationAddedCompanyToLandscape.name = 'V3RegistrationAddedCompanyToLandscape';
    TrackingObject.V3RegistrationAddedCompanyToLandscape.module = 'Registration';

    TrackingObject.V3RegistrationRemovedCompanyFromLandscape = {};
    TrackingObject.V3RegistrationRemovedCompanyFromLandscape.name = 'V3RegistrationRemovedCompanyFromLandscape';
    TrackingObject.V3RegistrationRemovedCompanyFromLandscape.module = 'Registration';

    TrackingObject.V3RegistrationViewedLandscapeName = {};
    TrackingObject.V3RegistrationViewedLandscapeName.name = 'V3RegistrationViewedLandscapeName';
    TrackingObject.V3RegistrationViewedLandscapeName.module = 'Registration';

    TrackingObject.V3RegistrationCompletedLandscapeName = {};
    TrackingObject.V3RegistrationCompletedLandscapeName.name = 'V3RegistrationCompletedLandscapeName';
    TrackingObject.V3RegistrationCompletedLandscapeName.module = 'Registration';

    TrackingObject.V3RegistrationSubmit = {};
    TrackingObject.V3RegistrationSubmit.name = 'V3RegistrationSubmit';
    TrackingObject.V3RegistrationSubmit.module = 'Registration';

    TrackingObject.V3RegistrationEnteredApp = {};
    TrackingObject.V3RegistrationEnteredApp.name = 'V3RegistrationEnteredApp';
    TrackingObject.V3RegistrationEnteredApp.module = 'Registration';

    TrackingObject.V3RegistrationError = {};
    TrackingObject.V3RegistrationError.name = 'V3RegistrationError';
    TrackingObject.V3RegistrationError.module = 'Registration';

    TrackingObject.V3RegistrationWarning = {};
    TrackingObject.V3RegistrationWarning.name = 'V3RegistrationWarning';
    TrackingObject.V3RegistrationWarning.module = 'Registration';

    TrackingObject.V3PostRegistrationStarted = {};
    TrackingObject.V3PostRegistrationStarted.name = 'V3PostRegistrationStarted';
    TrackingObject.V3PostRegistrationStarted.module = 'PostRegistration';

    TrackingObject.V3PostRegistrationViewedCompanies = {};
    TrackingObject.V3PostRegistrationViewedCompanies.name = 'V3PostRegistrationViewedCompanies';
    TrackingObject.V3PostRegistrationViewedCompanies.module = 'PostRegistration';

    TrackingObject.V3AnalyzeUsedPowerMode = {};
    TrackingObject.V3AnalyzeUsedPowerMode.name = 'V3AnalyzeUsedPowerMode';
    TrackingObject.V3AnalyzeUsedPowerMode.module = 'Analyze';

    TrackingObject.V3UsedProfileManager = {};
    TrackingObject.V3UsedProfileManager.name = 'V3UsedProfileManager';
    TrackingObject.V3UsedProfileManager.module = 'Main';

    TrackingObject.V3AnalyzeViewedGraph = {};
    TrackingObject.V3AnalyzeViewedGraph.name = 'V3AnalyzeViewedGraph';
    TrackingObject.V3AnalyzeViewedGraph.module = 'Analyze';

    TrackingObject.V3AnalyzeTourForwardBack = {};
    TrackingObject.V3AnalyzeTourForwardBack.name = 'V3AnalyzeTourForwardBack';
    TrackingObject.V3AnalyzeTourForwardBack.module = 'Analyze';

    TrackingObject.GraphLegendClicked = {};
    TrackingObject.GraphLegendClicked.name = 'GraphLegendClicked';
    TrackingObject.GraphLegendClicked.module = 'Analyze';

    TrackingObject.V3ViewedWelcome = {};
    TrackingObject.V3ViewedWelcome.name = 'V3ViewedWelcome';
    TrackingObject.V3ViewedWelcome.module = 'Main';

    TrackingObject.V3SiteViewedPricing = {};
    TrackingObject.V3SiteViewedPricing.name = 'V3SiteViewedPricing';
    TrackingObject.V3SiteViewedPricing.module = 'Main';

    TrackingObject.SiteViewedPricingIndividual = {};
    TrackingObject.SiteViewedPricingIndividual.name = 'Site_Viewed_Pricing_IndividualIndividual';
    TrackingObject.SiteViewedPricingIndividual.module = 'Main';

    TrackingObject.ExpandedPricingTableFeatures = {};
    TrackingObject.ExpandedPricingTableFeatures.name = 'Expanded_Pricing_Table_Features';
    TrackingObject.ExpandedPricingTableFeatures.module = 'Main';

    TrackingObject.V3SiteViewedProduct = {};
    TrackingObject.V3SiteViewedProduct.name = 'V3SiteViewedProduct';
    TrackingObject.V3SiteViewedProduct.module = 'Main';

    TrackingObject.V3SiteViewedAgencies = {};
    TrackingObject.V3SiteViewedAgencies.name = 'V3SiteViewedAgencies';
    TrackingObject.V3SiteViewedAgencies.module = 'Main';

    TrackingObject.V3SiteViewedFacebookInsights = {};
    TrackingObject.V3SiteViewedFacebookInsights.name = 'V3SiteViewedFacebookInsights';
    TrackingObject.V3SiteViewedFacebookInsights.module = 'Main';

    TrackingObject.V3SiteViewedAbout = {};
    TrackingObject.V3SiteViewedAbout.name = 'V3SiteViewedAbout';
    TrackingObject.V3SiteViewedAbout.module = 'Main';

    TrackingObject.V3SiteViewedHomePage = {};
    TrackingObject.V3SiteViewedHomePage.name = 'V3SiteViewedHomePage';
    TrackingObject.V3SiteViewedHomePage.module = 'Main';

    TrackingObject.V3UsedExportInAnalyze = {};
    TrackingObject.V3UsedExportInAnalyze.name = 'V3UsedExportInAnalyze';
    TrackingObject.V3UsedExportInAnalyze.module = 'Analyze';

    TrackingObject.UsedPanelExportInAnalyze = {};
    TrackingObject.UsedPanelExportInAnalyze.name = 'Used_Panel_Export_In_Analyze';
    TrackingObject.UsedPanelExportInAnalyze.module = 'Analyze';

    TrackingObject.V3FinishedTour = {};
    TrackingObject.V3FinishedTour.name = 'V3FinishedTour';
    TrackingObject.V3FinishedTour.module = 'Main';

    TrackingObject.V3QuitTour = {};
    TrackingObject.V3QuitTour.name = 'V3QuitTour';
    TrackingObject.V3QuitTour.module = 'Main';

    TrackingObject.V3NextPointTour = {};
    TrackingObject.V3NextPointTour.name = 'V3NextPointTour';
    TrackingObject.V3NextPointTour.module = 'Main';

    TrackingObject.V3ViewedActivity = {};
    TrackingObject.V3ViewedActivity.name = 'V3ViewedActivity';
    TrackingObject.V3ViewedActivity.module = 'Main';

    TrackingObject.UsedExportInActivity = {};
    TrackingObject.UsedExportInActivity.name = 'Used_Export_In_Activity';
    TrackingObject.UsedExportInActivity.module = 'Main';

    TrackingObject.V3ViewedTopContent = {};
    TrackingObject.V3ViewedTopContent.name = 'V3ViewedTopContent';
    TrackingObject.V3ViewedTopContent.module = 'Content';


    TrackingObject.V3ViewedFocusCompanyTopContent = {};
    TrackingObject.V3ViewedFocusCompanyTopContent.name = 'V3ViewedHighlightTopContent';
    TrackingObject.V3ViewedFocusCompanyTopContent.module = 'Content';

    TrackingObject.ViewedCompanyProfileOverview = {};
    TrackingObject.ViewedCompanyProfileOverview.name = 'Viewed_Company_Profile_Overview';
    TrackingObject.ViewedCompanyProfileOverview.module = 'Company';

    TrackingObject.V3ViewedCompanyProfileContent = {};
    TrackingObject.V3ViewedCompanyProfileContent.name = 'V3ViewedCompanyProfileContent';
    TrackingObject.V3ViewedCompanyProfileContent.module = 'Content';

    TrackingObject.V3ViewedCompanyProfileEvents = {};
    TrackingObject.V3ViewedCompanyProfileEvents.name = 'V3ViewedCompanyProfileEvents';
    TrackingObject.V3ViewedCompanyProfileEvents.module = 'Events';

    TrackingObject.ViewedCompanyProfilePages = {};
    TrackingObject.ViewedCompanyProfilePages.name = 'Viewed_Company_Profile_Pages';
    TrackingObject.ViewedCompanyProfilePages.module = 'Company';

    TrackingObject.V3ViewedAnalyzeContent = {};
    TrackingObject.V3ViewedAnalyzeContent.name = 'V3ViewedAnalyzeContent';
    TrackingObject.V3ViewedAnalyzeContent.module = 'Content';

    TrackingObject.V3ChangedChannelInContent = {};
    TrackingObject.V3ChangedChannelInContent.name = 'V3ChangedChannelInContent';
    TrackingObject.V3ChangedChannelInContent.module = 'Content';

    TrackingObject.V3ChangedSortInContent = {};
    TrackingObject.V3ChangedSortInContent.name = 'V3ChangedSortInContent';
    TrackingObject.V3ChangedSortInContent.module = 'Content';

    TrackingObject.V3UsedExportInContent = {};
    TrackingObject.V3UsedExportInContent.name = 'V3UsedExportInContent';
    TrackingObject.V3UsedExportInContent.module = 'Content';

    TrackingObject.ViewedHomepageImage = {};
    TrackingObject.ViewedHomepageImage.name = 'ViewedHomepageImage';
    TrackingObject.ViewedHomepageImage.module = 'Homepage';

    TrackingObject.V3ViewedLandscapeSettings = {};
    TrackingObject.V3ViewedLandscapeSettings.name = 'V3ViewedLandscapeSettings';
    TrackingObject.V3ViewedLandscapeSettings.module = 'Settings';

    TrackingObject.V3ViewedLandscapeNotificationSettings = {};
    TrackingObject.V3ViewedLandscapeNotificationSettings.name = 'V3ViewedLandscapeNotificationSettings';
    TrackingObject.V3ViewedLandscapeNotificationSettings.module = 'Settings';
    TrackingObject.V3ViewedLandscapeNotificationSettings.trackInIntercom = true;

    TrackingObject.ViewedLandscapeBrandingSettings = {};
    TrackingObject.ViewedLandscapeBrandingSettings.name = 'Viewed_Landscape_Branding_Settings';
    TrackingObject.ViewedLandscapeBrandingSettings.module = 'Settings';

    TrackingObject.ViewedLandscapeSpamSettings = {};
    TrackingObject.ViewedLandscapeSpamSettings.name = 'Viewed_Landscape_Spam_Settings';
    TrackingObject.ViewedLandscapeSpamSettings.module = 'Settings';

    TrackingObject.ViewedLandscapeFacebookAdAccountSettings = {};
    TrackingObject.ViewedLandscapeFacebookAdAccountSettings.name = 'Viewed_Landscape_Facebook_Ad_Account_Settings';
    TrackingObject.ViewedLandscapeFacebookAdAccountSettings.module = 'Settings';

    TrackingObject.PPTThemeSelectedDefaultForEdit = {};
    TrackingObject.PPTThemeSelectedDefaultForEdit.name = 'PPTThemeSelectedDefaultForEdit';
    TrackingObject.PPTThemeSelectedDefaultForEdit.module = 'Settings';

    TrackingObject.PPTThemeSelectedCustomForEdit = {};
    TrackingObject.PPTThemeSelectedCustomForEdit.name = 'PPTThemeSelectedCustomForEdit';
    TrackingObject.PPTThemeSelectedCustomForEdit.module = 'Settings';

    TrackingObject.PPTThemeUploadLogo = {};
    TrackingObject.PPTThemeUploadLogo.name = 'PPTThemeUploadLogo';
    TrackingObject.PPTThemeUploadLogo.module = 'Settings';

    TrackingObject.PPTThemeSaved = {};
    TrackingObject.PPTThemeSaved.name = 'PPTThemeSaved';
    TrackingObject.PPTThemeSaved.module = 'Settings';

    TrackingObject.ToggledChannelVisibility = {};
    TrackingObject.ToggledChannelVisibility.name = 'ToggledChannelVisibility';
    TrackingObject.ToggledChannelVisibility.module = 'Settings';

    TrackingObject.V3ClickedShareLandscape = {};
    TrackingObject.V3ClickedShareLandscape.name = 'V3ClickedShareLandscape';
    TrackingObject.V3ClickedShareLandscape.module = 'share_landscape';

    TrackingObject.HomePageViewedVideo = {};
    TrackingObject.HomePageViewedVideo.name = 'HomePageViewedVideo';
    TrackingObject.HomePageViewedVideo.module = 'homepage';

    TrackingObject.V3UsedSingleReportInAnalyze = {};
    TrackingObject.V3UsedSingleReportInAnalyze.name = 'V3UsedSingleReportInAnalyze';
    TrackingObject.V3UsedSingleReportInAnalyze.module = 'Analyze';

    TrackingObject.V3UsedSelectedReportsInAnalyze = {};
    TrackingObject.V3UsedSelectedReportsInAnalyze.name = 'V3UsedSelectedReportsInAnalyze';
    TrackingObject.V3UsedSelectedReportsInAnalyze.module = 'Analyze';

    TrackingObject.V3UsedReportEmailToInAnalyze = {};
    TrackingObject.V3UsedReportEmailToInAnalyze.name = 'V3UsedReportEmailToInAnalyze';
    TrackingObject.V3UsedReportEmailToInAnalyze.module = 'Analyze';

    TrackingObject.ViewedReports = {};
    TrackingObject.ViewedReports.name = 'Viewed_Reports';
    TrackingObject.ViewedReports.module = 'Reports';

    TrackingObject.GeneratedReportsPPT = {};
    TrackingObject.GeneratedReportsPPT.name = 'Generated_Reports_PPT';
    TrackingObject.GeneratedReportsPPT.module = 'Reports';

    TrackingObject.GeneratedReportsScheduled = {};
    TrackingObject.GeneratedReportsScheduled.name = 'Generated_Reports_Scheduled';
    TrackingObject.GeneratedReportsScheduled.module = 'Reports';

    TrackingObject.V3UsedReportInLandscape = {};
    TrackingObject.V3UsedReportInLandscape.name = 'V3UsedReportInLandscape';
    TrackingObject.V3UsedReportInLandscape.module = 'Landscape';

    TrackingObject.V3UsedReportEmailToInLandscape = {};
    TrackingObject.V3UsedReportEmailToInLandscape.name = 'V3UsedReportEmailToInLandscape';
    TrackingObject.V3UsedReportEmailToInLandscape.module = 'Landscape';

    TrackingObject.V3UsedMarketLandscapeCompanySelector = {};
    TrackingObject.V3UsedMarketLandscapeCompanySelector.name = 'V3UsedMarketLandscapeCompanySelector';
    TrackingObject.V3UsedMarketLandscapeCompanySelector.module = 'Navbar';

    TrackingObject.V3UsedSearchBox = {};
    TrackingObject.V3UsedSearchBox.name = 'V3UsedSearchBox';
    TrackingObject.V3UsedSearchBox.module = 'Navbar';

    TrackingObject.ViewedOverview = {};
    TrackingObject.ViewedOverview.name = 'Viewed_Overview';
    TrackingObject.ViewedOverview.module = 'Overview';

    TrackingObject.ViewedOverviewReal = {};
    TrackingObject.ViewedOverviewReal.name = 'viewed_overview_real';
    TrackingObject.ViewedOverviewReal.module = 'Overview';

    TrackingObject.OpenedCompareModal = {};
    TrackingObject.OpenedCompareModal.name = 'opened_compare_modal';
    TrackingObject.OpenedCompareModal.module = 'Overview';

    TrackingObject.SavedCompareModal = {};
    TrackingObject.SavedCompareModal.name = 'saved_compare_modal';
    TrackingObject.SavedCompareModal.module = 'Overview';

    TrackingObject.OverviewExpandedSection = {};
    TrackingObject.OverviewExpandedSection.name = 'Overview_Expanded_Section';
    TrackingObject.OverviewExpandedSection.module = 'Overview';

    TrackingObject.OverviewViewedModal = {};
    TrackingObject.OverviewViewedModal.name = 'Overview_Viewed_Modal';
    TrackingObject.OverviewViewedModal.module = 'Overview';

    TrackingObject.V3TwoUXWelcome = {};
    TrackingObject.V3TwoUXWelcome.name = 'V3TwoUXWelcome';
    TrackingObject.V3TwoUXWelcome.module = 'TwoUX';


    TrackingObject.V3TwoUXDataReview = {};
    TrackingObject.V3TwoUXDataReview.name = 'V3TwoUXDataReview';
    TrackingObject.V3TwoUXDataReview.module = 'TwoUX';

    TrackingObject.V3TwoUXVideo = {};
    TrackingObject.V3TwoUXVideo.name = 'V3TwoUXVideo';
    TrackingObject.V3TwoUXVideo.module = 'TwoUX';

    TrackingObject.V3TwoUXWatchedVideo = {};
    TrackingObject.V3TwoUXWatchedVideo.name = 'V3TwoUXWatchedVideo';
    TrackingObject.V3TwoUXWatchedVideo.module = 'TwoUX';

    TrackingObject.V3ViewedCanceled = {};
    TrackingObject.V3ViewedCanceled.name = 'V3ViewedCanceled';
    TrackingObject.V3ViewedCanceled.module = 'Canceled';

    TrackingObject.V3ViewedClonePage = {};
    TrackingObject.V3ViewedClonePage.name = 'V3ViewedClonePage';
    TrackingObject.V3ViewedClonePage.module = 'Clone';

    TrackingObject.V3ClonePageConversion = {};
    TrackingObject.V3ClonePageConversion.name = 'V3ClonePageConversion';
    TrackingObject.V3ClonePageConversion.module = 'Clone';

    TrackingObject.V3ViewedAccountSettings = {};
    TrackingObject.V3ViewedAccountSettings.name = 'V3ViewedAccountSettings';
    TrackingObject.V3ViewedAccountSettings.module = 'AccountSettings';

    TrackingObject.ViewedAccountUsers = {};
    TrackingObject.ViewedAccountUsers.name = 'ViewedAccountUsers';
    TrackingObject.ViewedAccountUsers.module = 'AccountSettings';

    TrackingObject.InvitedUser = {};
    TrackingObject.InvitedUser.name = 'InvitedUser';
    TrackingObject.InvitedUser.module = 'AccountSettings';

    TrackingObject.ChangedEmail = {};
    TrackingObject.ChangedEmail.name = 'ChangedEmail';
    TrackingObject.ChangedEmail.module = 'AccountSettings';

    TrackingObject.UsedExportInReceipts = {};
    TrackingObject.UsedExportInReceipts.name = 'used_export_in_receipts';
    TrackingObject.UsedExportInReceipts.module = 'AccountSettings';

    TrackingObject.ViewedPages = {};
    TrackingObject.ViewedPages.name = 'viewed_pages';
    TrackingObject.ViewedPages.module = 'Pages';

    TrackingObject.ChangedPagesPageType = {};
    TrackingObject.ChangedPagesPageType.name = 'changed_pages_pagetype';
    TrackingObject.ChangedPagesPageType.module = 'Pages';

    TrackingObject.ChangedPagesNumUp = {};
    TrackingObject.ChangedPagesNumUp.name = 'changed_pages_numup';
    TrackingObject.ChangedPagesNumUp.module = 'Pages';

    TrackingObject.ViewedPageHistory = {};
    TrackingObject.ViewedPageHistory.name = 'viewed_page_history';
    TrackingObject.ViewedPageHistory.module = 'Pages';

    TrackingObject.UsedExportInPages = {};
    TrackingObject.UsedExportInPages.name = 'used_export_in_pages';
    TrackingObject.UsedExportInPages.module = 'Pages';

    TrackingObject.ClickedPageHistoryGifExport = {};
    TrackingObject.ClickedPageHistoryGifExport.name = 'click_page_history_gif_export';
    TrackingObject.ClickedPageHistoryGifExport.module = 'Pages';

    TrackingObject.V3ExportCSV = {};
    TrackingObject.V3ExportCSV.name = 'V3ExportCSV';
    TrackingObject.V3ExportCSV.module = 'Export';


    TrackingObject.V3ExportCSVContent = {};
    TrackingObject.V3ExportCSVContent.name = 'V3ExportCSVContent';
    TrackingObject.V3ExportCSVContent.module = 'Content';

    TrackingObject.V3ExportCSVAnalyze = {};
    TrackingObject.V3ExportCSVAnalyze.name = 'V3ExportCSVAnalyze';
    TrackingObject.V3ExportCSVAnalyze.module = 'Analyze';

    TrackingObject.V3ExportCSVSeoOverview = {};
    TrackingObject.V3ExportCSVSeoOverview.name = 'V3ExportCSVSeoOverview';
    TrackingObject.V3ExportCSVSeoOverview.module = 'SeoOverview';

    TrackingObject.ExportSeoOverview = {};
    TrackingObject.ExportSeoOverview.name = 'Export_SEO_Overview';
    TrackingObject.ExportSeoOverview.module = 'SeoOverview';

    TrackingObject.V3UpdatePlan = {};
    TrackingObject.V3UpdatePlan.name = 'V3UpdatePlan';
    TrackingObject.V3UpdatePlan.module = 'Subscription';

    TrackingObject.Upgraded = {};
    TrackingObject.Upgraded.name = 'Upgraded';
    TrackingObject.Upgraded.module = 'Subscription';

    TrackingObject.Downgraded = {};
    TrackingObject.Downgraded.name = 'Downgraded';
    TrackingObject.Downgraded.module = 'Subscription';

    TrackingObject.Billed = {};
    TrackingObject.Billed.name = 'Billed';
    TrackingObject.Billed.module = 'Subscription';

    TrackingObject.AddModalHitLimit = {};
    TrackingObject.AddModalHitLimit.name = 'AddModalHitLimit';
    TrackingObject.AddModalHitLimit.module = 'Subscription';


    TrackingObject.AddLandscapeHitLimit = {};
    TrackingObject.AddLandscapeHitLimit.name = 'Add_Landscape_Hit_Limit';
    TrackingObject.AddLandscapeHitLimit.module = 'Subscription';


    TrackingObject.ViewedExpiredPage = {};
    TrackingObject.ViewedExpiredPage.name = 'ViewedExpiredPage';
    TrackingObject.ViewedExpiredPage.module = 'Subscription';

    TrackingObject.OpenedChurnModal = {};
    TrackingObject.OpenedChurnModal.name = 'Opened_Churn_Modal';
    TrackingObject.OpenedChurnModal.module = 'Subscription';

    TrackingObject.SelfChurned = {};
    TrackingObject.SelfChurned.name = 'Self_Churned';
    TrackingObject.SelfChurned.module = 'Subscription';

    TrackingObject.SelfReactivated = {};
    TrackingObject.SelfReactivated.name = 'Self_Reactivated';
    TrackingObject.SelfReactivated.module = 'Subscription';

    TrackingObject.SubmittedDataChangeRequest = {};
    TrackingObject.SubmittedDataChangeRequest.name = 'SubmittedDataChangeRequest';
    TrackingObject.SubmittedDataChangeRequest.module = 'Company';

    TrackingObject.EditCompany = {};
    TrackingObject.EditCompany.name = 'edit_company';
    TrackingObject.EditCompany.module = 'Company';

    TrackingObject.TimePeriodCustomCreated = {};
    TrackingObject.TimePeriodCustomCreated.name = 'TimePeriodCustomCreated';
    TrackingObject.TimePeriodCustomCreated.module = 'CustomDateRanges';

    TrackingObject.TimePeriodCustomDeleted = {};
    TrackingObject.TimePeriodCustomDeleted.name = 'TimePeriodCustomDeleted';
    TrackingObject.TimePeriodCustomDeleted.module = 'CustomDateRanges';

    TrackingObject.TimePeriodCustomCompareCreated = {};
    TrackingObject.TimePeriodCustomCompareCreated.name = 'TimePeriodCustomCompareCreated';
    TrackingObject.TimePeriodCustomCompareCreated.module = 'CustomDateRanges';

    TrackingObject.TimePeriodCustomActivated = {};
    TrackingObject.TimePeriodCustomActivated.name = 'TimePeriodCustomActivated';
    TrackingObject.TimePeriodCustomActivated.module = 'CustomDateRanges';

    TrackingObject.TimePeriodPredefinedActivated = {};
    TrackingObject.TimePeriodPredefinedActivated.name = 'TimePeriodPredefinedActivated';
    TrackingObject.TimePeriodPredefinedActivated.module = 'CustomDateRanges';

    TrackingObject.FirstSessionStart = {};
    TrackingObject.FirstSessionStart.name = 'FirstSessionStart';
    TrackingObject.FirstSessionStart.module = 'Main';

    TrackingObject.ViewedSocialChannelMatrix = {};
    TrackingObject.ViewedSocialChannelMatrix.name = 'ViewedSocialChannelMatrix';
    TrackingObject.ViewedSocialChannelMatrix.module = 'SocialChannelMatrix';

    TrackingObject.UsedExportInSocialChannelMatrix = {};
    TrackingObject.UsedExportInSocialChannelMatrix.name = 'Used_Export_in_Social_Channel_Matrix';
    TrackingObject.UsedExportInSocialChannelMatrix.module = 'SocialChannelMatrix';

    TrackingObject.FinishedTourInSocialChannelMatrix = {};
    TrackingObject.FinishedTourInSocialChannelMatrix.name = 'Finished_Tour_Social_Channel_Matrix';
    TrackingObject.FinishedTourInSocialChannelMatrix.module = 'SocialChannelMatrix';

    TrackingObject.SubmittedChangeRequestInSocialChannelMatrix = {};
    TrackingObject.SubmittedChangeRequestInSocialChannelMatrix.name = 'Submitted_Change_Request_in_Social_Channel_Matrix';
    TrackingObject.SubmittedChangeRequestInSocialChannelMatrix.module = 'SocialChannelMatrix';

    TrackingObject.ViewedLandscapeModal = {};
    TrackingObject.ViewedLandscapeModal.name = 'Viewed_Landscape_Modal';
    TrackingObject.ViewedLandscapeModal.module = 'Main';

    TrackingObject.CreatedLandscape = {};
    TrackingObject.CreatedLandscape.name = 'Created_Landscape';
    TrackingObject.CreatedLandscape.module = 'Main';

    TrackingObject.RenamedLandscape = {};
    TrackingObject.RenamedLandscape.name = 'Renamed_Landscape';
    TrackingObject.RenamedLandscape.module = 'Main';

    TrackingObject.DeletedLandscape = {};
    TrackingObject.DeletedLandscape.name = 'Deleted_Landscape';
    TrackingObject.DeletedLandscape.module = 'Main';

    TrackingObject.ActivatedLandscape = {};
    TrackingObject.ActivatedLandscape.name = 'Activated_Landscape';
    TrackingObject.ActivatedLandscape.module = 'Main';

    TrackingObject.ClickedAddCompanies = {};
    TrackingObject.ClickedAddCompanies.name = 'clicked_add_companies';
    TrackingObject.ClickedAddCompanies.module = 'Main';

    TrackingObject.HitAddCompanyLimit = {};
    TrackingObject.HitAddCompanyLimit.name = 'hit_add_company_limit';
    TrackingObject.HitAddCompanyLimit.module = 'Main';

    TrackingObject.ClickedSubscribeButton = {};
    TrackingObject.ClickedSubscribeButton.name = 'clicked_subscribe_button';
    TrackingObject.ClickedSubscribeButton.module = 'Main';

    TrackingObject.ClickedUpsellLink = {};
    TrackingObject.ClickedUpsellLink.name = 'clicked_upsell_link';
    TrackingObject.ClickedUpsellLink.module = 'Main';

    TrackingObject.ClickedUpsellLinkReview = {};
    TrackingObject.ClickedUpsellLinkReview.name = 'clicked_upsell_link_review';
    TrackingObject.ClickedUpsellLinkReview.module = 'Main';

    TrackingObject.ClickedUpsellLinkSuccess = {};
    TrackingObject.ClickedUpsellLinkSuccess.name = 'clicked_upsell_link_success';
    TrackingObject.ClickedUpsellLinkSuccess.module = 'Main';

    TrackingObject.CsmDetailsClickedCalendly = {};
    TrackingObject.CsmDetailsClickedCalendly.name = 'CSM_Details_Clicked_Calendly';
    TrackingObject.CsmDetailsClickedCalendly.module = 'Main';

    TrackingObject.CompanyAddViaModal = {};
    TrackingObject.CompanyAddViaModal.name = 'Company_Add_Via_Modal';
    TrackingObject.CompanyAddViaModal.module = 'Main';

    TrackingObject.CompanyRemoveFromLandscape = {};
    TrackingObject.CompanyRemoveFromLandscape.name = 'Company_Remove_From_Landscape';
    TrackingObject.CompanyRemoveFromLandscape.module = 'Main';

    TrackingObject.ChangedFocusCompany = {};
    TrackingObject.ChangedFocusCompany.name = 'Changed_Focus_Company';
    TrackingObject.ChangedFocusCompany.module = 'Main';

    TrackingObject.ViewedFavorites = {};
    TrackingObject.ViewedFavorites.name = 'Viewed_Favorites';
    TrackingObject.ViewedFavorites.module = 'Analyze';

    TrackingObject.AddFavoriteChartAnalyze = {};
    TrackingObject.AddFavoriteChartAnalyze.name = 'Add_Favorite_Chart_From_Analyze';
    TrackingObject.AddFavoriteChartAnalyze.module = 'Analyze';

    TrackingObject.RemoveFavoriteChartAnalyze = {};
    TrackingObject.RemoveFavoriteChartAnalyze.name = 'Remove_Favorite_Chart_From_Analyze';
    TrackingObject.RemoveFavoriteChartAnalyze.module = 'Analyze';

    TrackingObject.UndoRemoveFavoriteChartAnalyze = {};
    TrackingObject.UndoRemoveFavoriteChartAnalyze.name = 'Undo_Remove_Favorite_Chart_From_Analyze';
    TrackingObject.UndoRemoveFavoriteChartAnalyze.module = 'Analyze';

    TrackingObject.ViewedCustomChartCreator = {};
    TrackingObject.ViewedCustomChartCreator.name = 'Viewed_Custom_Chart_Creator';
    TrackingObject.ViewedCustomChartCreator.module = 'Analyze';

    TrackingObject.SavedCustomChart = {};
    TrackingObject.SavedCustomChart.name = 'Saved_Custom_Chart';
    TrackingObject.SavedCustomChart.module = 'Analyze';

    // Favorites
    TrackingObject.FavoritesReorderOpen = {};
    TrackingObject.FavoritesReorderOpen.name = 'favorites_reorder_open';
    TrackingObject.FavoritesReorderOpen.module = 'Favorites';

    TrackingObject.FavoritesSaveTo = {};
    TrackingObject.FavoritesSaveTo.name = 'chart_builder_save_to_favorites';
    TrackingObject.FavoritesSaveTo.module = 'Favorites';

    TrackingObject.FavoritesChartSave = {};
    TrackingObject.FavoritesChartSave.name = 'chart_builder_save_as_new';
    TrackingObject.FavoritesChartSave.module = 'Favorites';

    TrackingObject.FavoritesChartUpdate = {};
    TrackingObject.FavoritesChartUpdate.name = 'chart_builder_update_existing';
    TrackingObject.FavoritesChartUpdate.module = 'Favorites';

    TrackingObject.FavoritesChartEdit = {};
    TrackingObject.FavoritesChartEdit.name = 'favorites_edit';
    TrackingObject.FavoritesChartEdit.module = 'Favorites';

    TrackingObject.FavoritesChartDelete = {};
    TrackingObject.FavoritesChartDelete.name = 'favorites_delete';
    TrackingObject.FavoritesChartDelete.module = 'Favorites';

    TrackingObject.FavoritesClickedReadOnlyInvite = {};
    TrackingObject.FavoritesClickedReadOnlyInvite.name = 'favorites_clicked_read_only_invite';
    TrackingObject.FavoritesClickedReadOnlyInvite.module = 'Favorites';

    TrackingObject.ViewedCustomDashboardAuthWidget = {};
    TrackingObject.ViewedCustomDashboardAuthWidget.name = 'custom_dashboard_hidden_panel_shown';
    TrackingObject.ViewedCustomDashboardAuthWidget.module = 'Dashboard';

    TrackingObject.ClickedCustomDashboardAuthButton = {};
    TrackingObject.ClickedCustomDashboardAuthButton.name = 'custom_dashboard_hidden_panel_auth';
    TrackingObject.ClickedCustomDashboardAuthButton.module = 'Dashboard';

    TrackingObject.ViewedDetailedMetrics = {};
    TrackingObject.ViewedDetailedMetrics.name = 'Viewed_Detailed_Metrics';
    TrackingObject.ViewedDetailedMetrics.module = 'Analyze';

    TrackingObject.ViewedPositioningMetrics = {};
    TrackingObject.ViewedPositioningMetrics.name = 'Viewed_Positioning_Metrics';
    TrackingObject.ViewedPositioningMetrics.module = 'Analyze';

    TrackingObject.ExpandedChartPanel = {};
    TrackingObject.ExpandedChartPanel.name = 'Expanded_Chart_Panel';
    TrackingObject.ExpandedChartPanel.module = 'Analyze';

    TrackingObject.CollapsedChartPanel = {};
    TrackingObject.CollapsedChartPanel.name = 'Collapsed_Chart_Panel';
    TrackingObject.CollapsedChartPanel.module = 'Analyze';

    TrackingObject.ViewedHelpPage = {};
    TrackingObject.ViewedHelpPage.name = 'Viewed_Help_Page';
    TrackingObject.ViewedHelpPage.module = 'Help';

    TrackingObject.ViewedHelpModal = {};
    TrackingObject.ViewedHelpModal.name = 'Viewed_Help_Modal';
    TrackingObject.ViewedHelpModal.module = 'Help';

    TrackingObject.WatchedHelpVideoBasics = {};
    TrackingObject.WatchedHelpVideoBasics.name = 'Watched_Help_Video_Basics';
    TrackingObject.WatchedHelpVideoBasics.module = 'Help';

    TrackingObject.WatchedHelpVideoSocialContent = {};
    TrackingObject.WatchedHelpVideoSocialContent.name = 'Watched_Help_Video_Social_Content';
    TrackingObject.WatchedHelpVideoSocialContent.module = 'Help';

    TrackingObject.WatchedHelpVideoPptReports = {};
    TrackingObject.WatchedHelpVideoPptReports.name = 'Watched_Help_Video_Ppt_Reports';
    TrackingObject.WatchedHelpVideoPptReports.module = 'Help';

    TrackingObject.V3ViewedEvents = {};
    TrackingObject.V3ViewedEvents.name = 'V3ViewedEvents';
    TrackingObject.V3ViewedEvents.module = 'Events';

    TrackingObject.V3EventsExpandedMetricPosts = {};
    TrackingObject.V3EventsExpandedMetricPosts.name = 'V3EventsExpandedMetricPosts';
    TrackingObject.V3EventsExpandedMetricPosts.module = 'Events';

    TrackingObject.UsedExportInEvents = {};
    TrackingObject.UsedExportInEvents.name = 'Used_Export_In_Events';
    TrackingObject.UsedExportInEvents.module = 'Events';

    TrackingObject.ViewedWebinarVideoPage = {};
    TrackingObject.ViewedWebinarVideoPage.name = 'Viewed_Webinar_Video_Page';
    TrackingObject.ViewedWebinarVideoPage.module = 'Webinar';

    TrackingObject.WatchedWebinarVideo = {};
    TrackingObject.WatchedWebinarVideo.name = 'Watched_Webinar_Video';
    TrackingObject.WatchedWebinarVideo.module = 'Webinar';

    TrackingObject.OverviewViewedChannel = {};
    TrackingObject.OverviewViewedChannel.name = 'Overview_Viewed_Channel';
    TrackingObject.OverviewViewedChannel.module = 'Overview';

    TrackingObject.V3UsedExportInOverview = {};
    TrackingObject.V3UsedExportInOverview.name = 'V3UsedExportInOverview';
    TrackingObject.V3UsedExportInOverview.module = 'Analyze';

    TrackingObject.ViewedLandingPage = {};
    TrackingObject.ViewedLandingPage.name = 'Viewed_Landing_Page';
    TrackingObject.ViewedLandingPage.module = 'LandingPage';

    TrackingObject.ViewedSignupPage = {};
    TrackingObject.ViewedSignupPage.name = 'Viewed_Signup_Page';
    TrackingObject.ViewedSignupPage.module = 'SignupPage';

    TrackingObject.WatchedLandingPageVideo = {};
    TrackingObject.WatchedLandingPageVideo.name = 'Watched_Landing_Page_Video';
    TrackingObject.WatchedLandingPageVideo.module = 'LandingPage';

    TrackingObject.SuspendedUserViewedAccountSuspendedPage = {};
    TrackingObject.SuspendedUserViewedAccountSuspendedPage.name = 'Suspended_User_Viewed_Account_Suspended_Page';
    TrackingObject.SuspendedUserViewedAccountSuspendedPage.module = 'AccountSuspended';

    TrackingObject.ViewedOnboardingModal = {};
    TrackingObject.ViewedOnboardingModal.name = 'Viewed_Onboarding_Modal';
    TrackingObject.ViewedOnboardingModal.module = 'Main';

    TrackingObject.ClickedScheduleInOnboardingModal = {};
    TrackingObject.ClickedScheduleInOnboardingModal.name = 'Clicked_Schedule_In_Onboarding_Modal';
    TrackingObject.ClickedScheduleInOnboardingModal.module = 'Main';

    TrackingObject.ViewedContactUsModal = {};
    TrackingObject.ViewedContactUsModal.name = 'Viewed_Contact_Us_Modal';
    TrackingObject.ViewedContactUsModal.module = 'Main';

    TrackingObject.SubmittedContactUsModal = {};
    TrackingObject.SubmittedContactUsModal.name = 'Submitted_Contact_Us_Modal';
    TrackingObject.SubmittedContactUsModal.module = 'Main';

    TrackingObject.ViewedContactUsForm = {};
    TrackingObject.ViewedContactUsForm.name = 'Viewed_Contact_Us_Form';
    TrackingObject.ViewedContactUsForm.module = 'Marketing';

    TrackingObject.SubmittedContactUsForm = {};
    TrackingObject.SubmittedContactUsForm.name = 'Submitted_Contact_Us_Form';
    TrackingObject.SubmittedContactUsForm.module = 'Marketing';

    TrackingObject.GotToSchedulingStage = {};
    TrackingObject.GotToSchedulingStage.name = 'Got_To_Scheduling_Stage';
    TrackingObject.GotToSchedulingStage.module = 'Marketing';

    TrackingObject.ChoseSchedulingMethodCalendly = {};
    TrackingObject.ChoseSchedulingMethodCalendly.name = 'Chose_Scheduling_Method_Calendly';
    TrackingObject.ChoseSchedulingMethodCalendly.module = 'Marketing';

    TrackingObject.ChoseSchedulingMethodJustContactMe = {};
    TrackingObject.ChoseSchedulingMethodJustContactMe.name = 'Chose_Scheduling_Method_Just_Contact_Me';
    TrackingObject.ChoseSchedulingMethodJustContactMe.module = 'Marketing';

    TrackingObject.ExitedModalAtSchedulingStage = {};
    TrackingObject.ExitedModalAtSchedulingStage.name = 'Exited_Modal_At_Scheduling_Stage';
    TrackingObject.ExitedModalAtSchedulingStage.module = 'Marketing';

    TrackingObject.PlayedVideoDemo = {};
    TrackingObject.PlayedVideoDemo.name = 'Played_Video_Demo';
    TrackingObject.PlayedVideoDemo.module = 'Marketing';

    TrackingObject.CustomDateRangeApplied = {};
    TrackingObject.CustomDateRangeApplied.name = 'Custom_Date_Range_Applied';
    TrackingObject.CustomDateRangeApplied.module = 'CustomDateRanges';

    TrackingObject.CreatedCompanyTag = {};
    TrackingObject.CreatedCompanyTag.name = 'Created_Company_Tag';
    TrackingObject.CreatedCompanyTag.module = 'Main';
    TrackingObject.CreatedCompanyTag.trackInIntercom = true;

    TrackingObject.DeletedCompanyTag = {};
    TrackingObject.DeletedCompanyTag.name = 'Removed_Company_Tag';
    TrackingObject.DeletedCompanyTag.module = 'Main';

    TrackingObject.ActivatedTag = {};
    TrackingObject.ActivatedTag.name = 'Activated_Tag';
    TrackingObject.ActivatedTag.module = 'Main';

    TrackingObject.ViewedReceipts = {};
    TrackingObject.ViewedReceipts.name = 'Viewed_Receipts';
    TrackingObject.ViewedReceipts.module = 'Main';

    TrackingObject.ViewedReceiptsSettings = {};
    TrackingObject.ViewedReceiptsSettings.name = 'Viewed_Receipts_Settings';
    TrackingObject.ViewedReceiptsSettings.module = 'Main';

    TrackingObject.UsedExportInDashboard = {};
    TrackingObject.UsedExportInDashboard.name = 'Used_Export_In_Dashboard';
    TrackingObject.UsedExportInDashboard.module = 'Dashboard';

    TrackingObject.ViewedDashboard = {};
    TrackingObject.ViewedDashboard.name = 'Viewed_Dashboard';
    TrackingObject.ViewedDashboard.module = 'Dashboard';

    TrackingObject.ViewedDashboardAlert = {};
    TrackingObject.ViewedDashboardAlert.name = 'Viewed_Dashboard_Alert';
    TrackingObject.ViewedDashboardAlert.module = 'Dashboard';

    TrackingObject.ViewedDashboardMentioner = {};
    TrackingObject.ViewedDashboardMentioner.name = 'Viewed_Dashboard_Mentioner';
    TrackingObject.ViewedDashboardMentioner.module = 'Dashboard';

    TrackingObject.ViewedDashboardLandscapeMentioners = {};
    TrackingObject.ViewedDashboardLandscapeMentioners.name = 'Viewed_Dashboard_Landscape_Mentioners';
    TrackingObject.ViewedDashboardLandscapeMentioners.module = 'Dashboard';

    TrackingObject.ViewedDashboardTopPostsBySort = {};
    TrackingObject.ViewedDashboardTopPostsBySort.name = 'Viewed_Dashboard_Top_Posts_By_Sort';
    TrackingObject.ViewedDashboardTopPostsBySort.module = 'Dashboard';

    TrackingObject.HidDashboardWidget = {};
    TrackingObject.HidDashboardWidget.name = 'Hid_Dashboard_Widget';
    TrackingObject.HidDashboardWidget.module = 'Dashboard';

    TrackingObject.ViewedOverCompanyLimitModal = {};
    TrackingObject.ViewedOverCompanyLimitModal.name = 'Viewed_Over_Company_Limit_Modal';
    TrackingObject.ViewedOverCompanyLimitModal.module = 'Companies';

    TrackingObject.ForsookUpgrade = {};
    TrackingObject.ForsookUpgrade.name = 'Forsook_Upgrade';
    TrackingObject.ForsookUpgrade.module = 'Companies';

    TrackingObject.HitTrialReportLimit = {};
    TrackingObject.HitTrialReportLimit.name = 'Hit_Trial_Report_Limit';
    TrackingObject.HitTrialReportLimit.module = 'Reports';

    TrackingObject.ViewedChannelWall = {};
    TrackingObject.ViewedChannelWall.name = 'Viewed_Channel_Wall';
    TrackingObject.ViewedChannelWall.module = 'Main';

    TrackingObject.ViewedInsightsPostModal = {};
    TrackingObject.ViewedInsightsPostModal.name = 'Viewed_Insights_Post_Modal';
    TrackingObject.ViewedInsightsPostModal.module = 'Insights';

    TrackingObject.ViewedInsightsPostDetails = {};
    TrackingObject.ViewedInsightsPostDetails.name = 'Viewed_Insights_Post_Details';
    TrackingObject.ViewedInsightsPostDetails.module = 'Insights';

    TrackingObject.SortedInsightsPostDetails = {};
    TrackingObject.SortedInsightsPostDetails.name = 'Sorted_Insights_Post_Details';
    TrackingObject.SortedInsightsPostDetails.module = 'Insights';
    TrackingObject.SortedInsightsPostDetails.trackInIntercom = true;

    TrackingObject.ViewedInsightsPostsModal = {};
    TrackingObject.ViewedInsightsPostsModal.name = 'Viewed_Insights_Posts_Modal';
    TrackingObject.ViewedInsightsPostsModal.module = 'Insights';

    TrackingObject.SetInsightsTimeZone = {};
    TrackingObject.SetInsightsTimeZone.name = 'Set_Insights_Time_Zone';
    TrackingObject.SetInsightsTimeZone.module = 'Insights';

    TrackingObject.ViewedInsights = {};
    TrackingObject.ViewedInsights.name = 'Viewed_Insights';
    TrackingObject.ViewedInsights.module = 'Insights';

    TrackingObject.ChangedInsightsCompany = {};
    TrackingObject.ChangedInsightsCompany.name = 'Changed_Insights_Company';
    TrackingObject.ChangedInsightsCompany.module = 'Insights';

    TrackingObject.ChangedInsightsPostType = {};
    TrackingObject.ChangedInsightsPostType.name = 'Changed_Insights_Post_Type';
    TrackingObject.ChangedInsightsPostType.module = 'Insights';

    TrackingObject.ViewedInsightsManageColumnsModal = {};
    TrackingObject.ViewedInsightsManageColumnsModal.name = 'Viewed_Insights_Manage_Columns_Modal';
    TrackingObject.ViewedInsightsManageColumnsModal.module = 'Insights';

    TrackingObject.InsightsSetObjectTypeFilter = {};
    TrackingObject.InsightsSetObjectTypeFilter.name = 'Insights_Set_Object_Type_Filter';
    TrackingObject.InsightsSetObjectTypeFilter.module = 'Insights';

    TrackingObject.InsightsSetMediaTypeFilter = {};
    TrackingObject.InsightsSetMediaTypeFilter.name = 'Insights_Set_Media_Type_Filter';
    TrackingObject.InsightsSetMediaTypeFilter.module = 'Insights';

    TrackingObject.InsightsSetSearchTerm = {};
    TrackingObject.InsightsSetSearchTerm.name = 'Insights_Set_Search_Term';
    TrackingObject.InsightsSetSearchTerm.module = 'Insights';

    TrackingObject.ViewedInsightsMetricsModal = {};
    TrackingObject.ViewedInsightsMetricsModal.name = 'ViewedInsightsMetricsModal';
    TrackingObject.ViewedInsightsMetricsModal.module = 'Insights';

    TrackingObject.SavedInsightsMetrics = {};
    TrackingObject.SavedInsightsMetrics.name = 'SavedInsightsMetrics';
    TrackingObject.SavedInsightsMetrics.module = 'Insights';

    TrackingObject.InstagramInsightsSearchedFromHashtags = {};
    TrackingObject.InstagramInsightsSearchedFromHashtags.name = 'Instagram_Insights_Searched_From_Hashtags';
    TrackingObject.InstagramInsightsSearchedFromHashtags.module = 'Insights';

    TrackingObject.V3ViewedFacebookAdsMetricsModal = {};
    TrackingObject.V3ViewedFacebookAdsMetricsModal.name = 'V3ViewedFacebookAdsMetricsModal';
    TrackingObject.V3ViewedFacebookAdsMetricsModal.module = 'AdsInsights';

    TrackingObject.V3SavedFacebookAdsMetrics = {};
    TrackingObject.V3SavedFacebookAdsMetrics.name = 'V3SavedFacebookAdsMetrics';
    TrackingObject.V3SavedFacebookAdsMetrics.module = 'AdsInsights';

    TrackingObject.V3ViewedFacebookAdsAdObjectDetailsModal = {};
    TrackingObject.V3ViewedFacebookAdsAdObjectDetailsModal.name = 'V3ViewedFacebookAdsAdObjectDetailsModal';
    TrackingObject.V3ViewedFacebookAdsAdObjectDetailsModal.module = 'AdsInsights';

    TrackingObject.V3ChangedFacebookAdsFilter = {};
    TrackingObject.V3ChangedFacebookAdsFilter.name = 'V3ChangedFacebookAdsFilter';
    TrackingObject.V3ChangedFacebookAdsFilter.module = 'AdsInsights';
    TrackingObject.V3ChangedFacebookAdsFilter.trackInIntercom = true;

    TrackingObject.StartedWidgetEditing = {};
    TrackingObject.StartedWidgetEditing.name = 'Started_Widget_Editing';
    TrackingObject.StartedWidgetEditing.module = 'Dashboard';

    TrackingObject.CancelledWidgetEditing = {};
    TrackingObject.CancelledWidgetEditing.name = 'Cancelled_Widget_Editing';
    TrackingObject.CancelledWidgetEditing.module = 'Dashboard';

    TrackingObject.SavedWidgetEdits = {};
    TrackingObject.SavedWidgetEdits.name = 'Saved_Widget_Edits';
    TrackingObject.SavedWidgetEdits.module = 'Dashboard';

    TrackingObject.ClickedViewPostTagManager = {};
    TrackingObject.ClickedViewPostTagManager.name = 'Clicked_View_Post_Tag_Manager';
    TrackingObject.ClickedViewPostTagManager.module = 'SocialPosts';

    TrackingObject.ClickedCreateNewRule = {};
    TrackingObject.ClickedCreateNewRule.name = 'Clicked_Create_New_Rule';
    TrackingObject.ClickedCreateNewRule.module = 'SocialPosts';

    TrackingObject.SelectedAutoTagRule = {};
    TrackingObject.SelectedAutoTagRule.name = 'Selected_Auto_Tag_Rule';
    TrackingObject.SelectedAutoTagRule.module = 'SocialPosts';

    TrackingObject.CreateNewPostTag = {};
    TrackingObject.CreateNewPostTag.name = 'Create_New_Post_Tag';
    TrackingObject.CreateNewPostTag.module = 'SocialPosts';

    TrackingObject.ChangePostWidgetLayout = {};
    TrackingObject.ChangePostWidgetLayout.name = 'Change_Post_Widget_Layout';
    TrackingObject.ChangePostWidgetLayout.module = 'SocialPosts';

    TrackingObject.ViewedTopVsBottom = {};
    TrackingObject.ViewedTopVsBottom.name = 'Viewed_TopVsBottom';
    TrackingObject.ViewedTopVsBottom.module = 'SocialPosts';
    TrackingObject.ViewedTopVsBottom.trackInIntercom = true;

    TrackingObject.ViewedPostTagManager = {};
    TrackingObject.ViewedPostTagManager.name = 'Viewed_Post_Tag_Manager';
    TrackingObject.ViewedPostTagManager.module = 'PostTagManager';
    TrackingObject.ViewedPostTagManager.trackInIntercom = true;

    TrackingObject.ClosedPostTagManager = {};
    TrackingObject.ClosedPostTagManager.name = 'Closed_Post_Tag_Manager';
    TrackingObject.ClosedPostTagManager.module = 'PostTagManager';

    TrackingObject.AppliedPostTags = {};
    TrackingObject.AppliedPostTags.name = 'Applied_Post_Tags_Manager';
    TrackingObject.AppliedPostTags.module = 'PostTagManager';
    TrackingObject.AppliedPostTags.trackInIntercom = true;

    TrackingObject.ClickedCreateRule = {};
    TrackingObject.ClickedCreateRule.name = 'Clicked_Create_Rule';
    TrackingObject.ClickedCreateRule.module = 'PostTagManager';

    TrackingObject.ClickedEditRule = {};
    TrackingObject.ClickedEditRule.name = 'Clicked_Edit_Rule';
    TrackingObject.ClickedEditRule.module = 'PostTagManager';

    TrackingObject.CreatedPostTaggingRule = {};
    TrackingObject.CreatedPostTaggingRule.name = 'Created_Post_Tagging_Rule';
    TrackingObject.CreatedPostTaggingRule.module = 'PostTagManager';
    TrackingObject.CreatedPostTaggingRule.trackInIntercom = true;

    TrackingObject.OpenedAutoTagRuleModal = {};
    TrackingObject.OpenedAutoTagRuleModal.name = 'Opened_Auto_Tag_Rule_Modal';
    TrackingObject.OpenedAutoTagRuleModal.module = 'PostTagManager';
    TrackingObject.OpenedAutoTagRuleModal.trackInIntercom = true;

    TrackingObject.RulesSetSearchTerm = {};
    TrackingObject.RulesSetSearchTerm.name = 'Rules_Set_Search_Term';
    TrackingObject.RulesSetSearchTerm.module = 'PostTagManager';

    TrackingObject.ClickedSearchTips = {};
    TrackingObject.ClickedSearchTips.name = 'Clicked_Search_Tips';
    TrackingObject.ClickedSearchTips.module = 'PostTagManager';

    TrackingObject.ToggledPostsSelectAll = {};
    TrackingObject.ToggledPostsSelectAll.name = 'Toggled_Posts_Select_All';
    TrackingObject.ToggledPostsSelectAll.module = 'PostTagManager';

    TrackingObject.ToggledShowPostTags = {};
    TrackingObject.ToggledShowPostTags.name = 'Toggled_Show_Post_Tags_Manager';
    TrackingObject.ToggledShowPostTags.module = 'SocialPosts';

    TrackingObject.ToggledShowSummaryRow = {};
    TrackingObject.ToggledShowSummaryRow.name = 'Toggled_Show_Summary_Row';
    TrackingObject.ToggledShowSummaryRow.module = 'SocialPosts';

    TrackingObject.ViewedSocialPosts = {};
    TrackingObject.ViewedSocialPosts.name = 'Viewed_Social_Posts';
    TrackingObject.ViewedSocialPosts.module = 'SocialPosts';

    TrackingObject.ViewedSocialPostsReal = {};
    TrackingObject.ViewedSocialPostsReal.name = 'viewed_socialposts_real';
    TrackingObject.ViewedSocialPostsReal.module = 'SocialPosts';

    TrackingObject.ViewedSocialPostsPostModal = {};
    TrackingObject.ViewedSocialPostsPostModal.name = 'Viewed_Social_Posts_Post_Modal';
    TrackingObject.ViewedSocialPostsPostModal.module = 'SocialPosts';

    TrackingObject.SocialPostsSetSearchTerm = {};
    TrackingObject.SocialPostsSetSearchTerm.name = 'Social_Posts_Set_Search_Term';
    TrackingObject.SocialPostsSetSearchTerm.module = 'SocialPosts';
    TrackingObject.SocialPostsSetSearchTerm.trackInIntercom = true;

    TrackingObject.SocialPostsSetTypeFilter = {};
    TrackingObject.SocialPostsSetTypeFilter.name = 'Social_Posts_Set_Type_Filter';
    TrackingObject.SocialPostsSetTypeFilter.module = 'SocialPosts';

    TrackingObject.SocialPostsSetTweetTypeFilter = {};
    TrackingObject.SocialPostsSetTweetTypeFilter.name = 'Social_Posts_Set_Tweet_Type_Filter';
    TrackingObject.SocialPostsSetTweetTypeFilter.module = 'SocialPosts';

    TrackingObject.SocialPostsSetBoostedPostFilter = {};
    TrackingObject.SocialPostsSetBoostedPostFilter.name = 'Social_Posts_Set_Boosted_Post_Filter';
    TrackingObject.SocialPostsSetBoostedPostFilter.module = 'SocialPosts';

    TrackingObject.SocialPostsSetDomainModeFilter = {};
    TrackingObject.SocialPostsSetDomainModeFilter.name = 'Social_Posts_Set_Domain_Mode_Filter';
    TrackingObject.SocialPostsSetDomainModeFilter.module = 'SocialPosts';

    TrackingObject.SocialPostsSetSearchFieldName = {};
    TrackingObject.SocialPostsSetSearchFieldName.name = 'Social_Posts_Set_Search_Field_Name';
    TrackingObject.SocialPostsSetSearchFieldName.module = 'SocialPosts';

    TrackingObject.SocialPostsSetPostTagIdsFilter = {};
    TrackingObject.SocialPostsSetPostTagIdsFilter.name = 'Social_Posts_Set_Post_Tag_Ids_Filter';
    TrackingObject.SocialPostsSetPostTagIdsFilter.module = 'SocialPosts';

    TrackingObject.SocialPostsExpandedTableRow = {};
    TrackingObject.SocialPostsExpandedTableRow.name = 'Social_Posts_Expanded_Table_Row';
    TrackingObject.SocialPostsExpandedTableRow.module = 'SocialPosts';

    TrackingObject.SocialPostsBrokenImageToast = {};
    TrackingObject.SocialPostsBrokenImageToast.name = 'Social_Posts_Broken_Image_Toast';
    TrackingObject.SocialPostsBrokenImageToast.module = 'SocialPosts';

    TrackingObject.PostedURLsClickedObservationDetails = {};
    TrackingObject.PostedURLsClickedObservationDetails.name = 'Posted_URLs_Clicked_Observation_Details';
    TrackingObject.PostedURLsClickedObservationDetails.module = 'PostedURLs';

    TrackingObject.PostedURLsExpandedTableRow = {};
    TrackingObject.PostedURLsExpandedTableRow.name = 'Posted_URLs_Expanded_Table_Row';
    TrackingObject.PostedURLsExpandedTableRow.module = 'PostedURLs';

    TrackingObject.PostedURLsViewPosts = {};
    TrackingObject.PostedURLsViewPosts.name = 'Posted_URLs_View_Posts';
    TrackingObject.PostedURLsViewPosts.module = 'PostedURLs';

    TrackingObject.SortedTable = {};
    TrackingObject.SortedTable.name = 'Sorted_Table';
    TrackingObject.SortedTable.module = 'Main';

    TrackingObject.SocialPostsViewDetails = {};
    TrackingObject.SocialPostsViewDetails.name = 'Social_Posts_View_Details';
    TrackingObject.SocialPostsViewDetails.module = 'SocialPosts';

    TrackingObject.SocialPostsViewPostsModal = {};
    TrackingObject.SocialPostsViewPostsModal.name = 'Social_Posts_View_Posts_Modal';
    TrackingObject.SocialPostsViewPostsModal.module = 'SocialPosts';

    TrackingObject.DownloadedSampleReportFromChannel = {};
    TrackingObject.DownloadedSampleReportFromChannel.name = 'Downloaded_Sample_Report_From_Channel';
    TrackingObject.DownloadedSampleReportFromChannel.module = 'Main';

    TrackingObject.ViewedMarketingBootcampWebinarPage = {};
    TrackingObject.ViewedMarketingBootcampWebinarPage.name = 'Viewed_Marketing_Bootcamp_Webinar_Page';
    TrackingObject.ViewedMarketingBootcampWebinarPage.module = 'Main';

    TrackingObject.ViewedChannelDetailsPage = {};
    TrackingObject.ViewedChannelDetailsPage.name = 'Viewed_Channel_Details_Page';
    TrackingObject.ViewedChannelDetailsPage.module = 'Main';

    TrackingObject.ViewedWebinarGrid = {};
    TrackingObject.ViewedWebinarGrid.name = 'Viewed_Webinar_Grid';
    TrackingObject.ViewedWebinarGrid.module = 'Main';

    TrackingObject.ViewedDataMismatchModal = {};
    TrackingObject.ViewedDataMismatchModal.name = 'Viewed_Data_Mismatch_Modal';
    TrackingObject.ViewedDataMismatchModal.module = 'Main';

    TrackingObject.LoadingViewTimeout = {};
    TrackingObject.LoadingViewTimeout.name = 'Loading_View_Timeout';
    TrackingObject.LoadingViewTimeout.module = 'Main';

    TrackingObject.ChangedGroupByInterval = {};
    TrackingObject.ChangedGroupByInterval.name = 'Changed_Group_By_Interval';
    TrackingObject.ChangedGroupByInterval.module = 'Main';

    TrackingObject.DownloadedAsset = {};
    TrackingObject.DownloadedAsset.name = 'Downloaded_Asset';
    TrackingObject.DownloadedAsset.module = 'LandingPage';

    TrackingObject.SubmittedLeadFormDownloadAsset = {};
    TrackingObject.SubmittedLeadFormDownloadAsset.name = 'Submitted_Lead_Form_Download_Asset';
    TrackingObject.SubmittedLeadFormDownloadAsset.module = 'LandingPage';

    TrackingObject.DatePickerV2Opened = {};
    TrackingObject.DatePickerV2Opened.name = 'date_picker_v2_opened';
    TrackingObject.DatePickerV2Opened.module = 'Main';

    TrackingObject.DatePickerV2PeriodSelected = {};
    TrackingObject.DatePickerV2PeriodSelected.name = 'date_picker_v2_period_selected';
    TrackingObject.DatePickerV2PeriodSelected.module = 'Main';

    TrackingObject.DatePickerV2Apply = {};
    TrackingObject.DatePickerV2Apply.name = 'date_picker_v2_apply';
    TrackingObject.DatePickerV2Apply.module = 'Main';
    TrackingObject.DatePickerV2Apply.trackInIntercom = true;

    TrackingObject.DatePickerV2MobileApply = {};
    TrackingObject.DatePickerV2MobileApply.name = 'date_picker_v2_mobile_apply';
    TrackingObject.DatePickerV2MobileApply.module = 'Main';

    TrackingObject.DatePickerV2Cancel = {};
    TrackingObject.DatePickerV2Cancel.name = 'date_picker_v2_cancel';
    TrackingObject.DatePickerV2Cancel.module = 'Main';

    TrackingObject.DatePickerV2ClickAway = {};
    TrackingObject.DatePickerV2ClickAway.name = 'date_picker_v2_click_away';
    TrackingObject.DatePickerV2ClickAway.module = 'Main';

    TrackingObject.SideBarSectionExpand = {};
    TrackingObject.SideBarSectionExpand.name = 'sidebar_section_expand';
    TrackingObject.SideBarSectionExpand.module = 'Main';

    TrackingObject.DashboardDelete = {};
    TrackingObject.DashboardDelete.name = 'dashboard_delete';
    TrackingObject.DashboardDelete.module = 'Main';

    TrackingObject.ViewedNeedsEmailVerification = {};
    TrackingObject.ViewedNeedsEmailVerification.name = 'Viewed_Needs_Email_Verification';
    TrackingObject.ViewedNeedsEmailVerification.module = 'Site';

    TrackingObject.ResentEmailVerification = {};
    TrackingObject.ResentEmailVerification.name = 'Resent_Email_Verification';
    TrackingObject.ResentEmailVerification.module = 'Site';

    TrackingObject.ResentEmailVerificationToNewEmail = {};
    TrackingObject.ResentEmailVerificationToNewEmail.name = 'Resent_Email_Verification_New_Email';
    TrackingObject.ResentEmailVerificationToNewEmail.module = 'Site';

    TrackingObject.ViewedEmailVerified = {};
    TrackingObject.ViewedEmailVerified.name = 'Viewed_Email_Verified';
    TrackingObject.ViewedEmailVerified.module = 'Site';

    TrackingObject.ViewedPurchaseBeforeEmailVerified = {};
    TrackingObject.ViewedPurchaseBeforeEmailVerified.name = 'Viewed_Purchase_Before_Email_Verified';
    TrackingObject.ViewedPurchaseBeforeEmailVerified.module = 'Main';

    TrackingObject.DiscoverySetSearchTerm = {};
    TrackingObject.DiscoverySetSearchTerm.name = 'Discovery_Set_Search_Term';
    TrackingObject.DiscoverySetSearchTerm.module = 'Discovery';
    TrackingObject.DiscoverySetSearchTerm.trackInIntercom = true;

    TrackingObject.DiscoveryAddFilter = {};
    TrackingObject.DiscoveryAddFilter.name = 'Discovery_Add_Filter';
    TrackingObject.DiscoveryAddFilter.module = 'Discovery';

    TrackingObject.DiscoveryViewedPostsModal = {};
    TrackingObject.DiscoveryViewedPostsModal.name = 'Discovery_Viewed_Posts_Modal';
    TrackingObject.DiscoveryViewedPostsModal.module = 'Discovery';

    TrackingObject.DiscoveryUsedFollowerCountFilter = {};
    TrackingObject.DiscoveryUsedFollowerCountFilter.name = 'Discovery_Used_Follower_Count_Filter';
    TrackingObject.DiscoveryUsedFollowerCountFilter.module = 'Discovery';

    TrackingObject.ViewedRenewalCenter = {};
    TrackingObject.ViewedRenewalCenter.name = 'Viewed_Renewal_Center';
    TrackingObject.ViewedRenewalCenter.module = 'RenewalCenter';

    TrackingObject.RenewalCenterPickedRenew = {};
    TrackingObject.RenewalCenterPickedRenew.name = 'Renewal_Center_Picked_Renew';
    TrackingObject.RenewalCenterPickedRenew.module = 'RenewalCenter';

    TrackingObject.RenewalCenterPickedHelp = {};
    TrackingObject.RenewalCenterPickedHelp.name = 'Renewal_Center_Picked_Help';
    TrackingObject.RenewalCenterPickedHelp.module = 'RenewalCenter';

    TrackingObject.RenewalCenterPickedDecline = {};
    TrackingObject.RenewalCenterPickedDecline.name = 'Renewal_Center_Picked_Decline';
    TrackingObject.RenewalCenterPickedDecline.module = 'RenewalCenter';

    TrackingObject.RenewalCenterClickedEmail = {};
    TrackingObject.RenewalCenterClickedEmail.name = 'Renewal_Center_Clicked_Email';
    TrackingObject.RenewalCenterClickedEmail.module = 'RenewalCenter';

    TrackingObject.RenewalCenterClickedPhone = {};
    TrackingObject.RenewalCenterClickedPhone.name = 'Renewal_Center_Clicked_Phone';
    TrackingObject.RenewalCenterClickedPhone.module = 'RenewalCenter';

    TrackingObject.RenewalCenterClickedCalendly = {};
    TrackingObject.RenewalCenterClickedCalendly.name = 'Renewal_Center_Clicked_Calendly';
    TrackingObject.RenewalCenterClickedCalendly.module = 'RenewalCenter';

    TrackingObject.InstagramAuditViewed = {};
    TrackingObject.InstagramAuditViewed.name = 'InstagramAudit_Viewed';
    TrackingObject.InstagramAuditViewed.module = 'InstagramAudit';

    TrackingObject.ClickedRefreshInstagramInsightsExpiredConnection = {};
    TrackingObject.ClickedRefreshInstagramInsightsExpiredConnection.name = 'Clicked_Refresh_Instagram_Insights_Expired_Connection';
    TrackingObject.ClickedRefreshInstagramInsightsExpiredConnection.module = 'RefreshExpiredConnection';

    TrackingObject.ClickedSupport = {};
    TrackingObject.ClickedSupport.name = 'Clicked_Support';
    TrackingObject.ClickedSupport.module = 'Clicked_Support';

    TrackingObject.ClickedSupportDemo = {};
    TrackingObject.ClickedSupportDemo.name = 'Clicked_Support_Demo';
    TrackingObject.ClickedSupportDemo.module = 'Clicked_Support';

    TrackingObject.ClickedEstimatedImpressionsUpsell = {};
    TrackingObject.ClickedEstimatedImpressionsUpsell.name = 'Clicked_Estimated_Impressions_Upsell';
    TrackingObject.ClickedEstimatedImpressionsUpsell.module = 'Main';

    TrackingObject.ViewedTagManager = {};
    TrackingObject.ViewedTagManager.name = 'Viewed_Tag_Manager';
    TrackingObject.ViewedTagManager.module = 'Main';

    TrackingObject.ViewedAdBlockerNag = {};
    TrackingObject.ViewedAdBlockerNag.name = 'Viewed_Ad_Blocker_Nag';
    TrackingObject.ViewedAdBlockerNag.module = 'Main';

    TrackingObject.NotificationsClickedRenewal = {};
    TrackingObject.NotificationsClickedRenewal.name = 'Notifications_Clicked_Renewal';
    TrackingObject.NotificationsClickedRenewal.module = 'Notifications';

    TrackingObject.ListeningSetSearchQueries = {};
    TrackingObject.ListeningSetSearchQueries.name = 'Listening_Set_Search_Queries';
    TrackingObject.ListeningSetSearchQueries.module = 'Listening';
    TrackingObject.ListeningSetSearchQueries.trackInIntercom = true;

    TrackingObject.ListeningClickedEdit = {};
    TrackingObject.ListeningClickedEdit.name = 'Listening_Clicked_Edit';
    TrackingObject.ListeningClickedEdit.module = 'Listening';

    TrackingObject.ListeningViewedResults = {};
    TrackingObject.ListeningViewedResults.name = 'Listening_Viewed_Results';
    TrackingObject.ListeningViewedResults.module = 'Listening';

    TrackingObject.ClickedListeningUpsell = {};
    TrackingObject.ClickedListeningUpsell.name = 'Clicked_Listening_Upsell';
    TrackingObject.ClickedListeningUpsell.module = 'Listening';

    TrackingObject.ListeningSearchWithin = {};
    TrackingObject.ListeningSearchWithin.name = 'Listening_Search_Within';
    TrackingObject.ListeningSearchWithin.module = 'Listening';


    // check that email got tracked

    const trackInIntercom = {
        viewed_facebook_ads_insights: true,
        viewed_chart_builder: true,
        viewed_facebook_insights_post_details: true,
        viewed_activity_overview: true,
        viewed_reach_overview: true,
        exported_overview: true,
        viewed_engagement_overview: true,
        viewed_charts_positioning: true,
        viewed_dashboards_builder: true,
        viewed_discovery: true,
        'viewed_posted-urls': true,
        viewed_alerts: true,
        viewed_instagram_insights_posts: true,
        viewed_twitter_analytics_profile: true,
        viewed_twitter_analytics_posts: true,
        viewed_socialposts_details_social_posts_keywords_table: true,
        'viewed_post-tags': true
    };

    function pageHasAccountState() {
        return (_.has(App, ['state', 'account']));
    }

    function isInternalUser() {

        if (!pageHasAccountState()) {
            return false;
        }

        return (App.state.account.isAdmin());
    }

    function trackingIdentify(email) {

        // exclude internal users
        if (!isInternalUser()) {

            if (email !== null) {

                if (typeof window._kmq !== 'undefined' && window._kmq !== null) {
                    window._kmq.push(['identify', email]);
                }

                if (typeof window._kiq !== 'undefined' && window._kiq !== null) {
                    window._kiq.push(['identify', email]);
                }

                if (typeof window.FS !== 'undefined' && pageHasAccountState() && App.state.user.get('id')) {

                    const fsCustomFields = {
                        displayName: `${App.state.user.get('first_name')} ${App.state.user.get('last_name')}`,
                        email: App.state.user.get('email'),
                        role: App.state.user.get('role_id'),
                        qualified: App.state.account.get('initialQual')
                    };

                    const accountConversionStatus = _.find(RivalIQ.enums.account.conversionStatuses, {
                        id: RivalIQ.state.account.get('accountConversionStatus')
                    });
                    fsCustomFields.accountConversionStatus = _.get(accountConversionStatus, ['name']);

                    // we need to tell fullstory the type of the "non system" custom fields
                    _.each(App.state.account.get('betaFeatures'), function (value, key) {
                        fsCustomFields[`${_.camelCase(key)}_bool`] = value;
                    });

                    window.FS.identify(App.state.user.get('id').toString(), fsCustomFields);
                }
            }
        }

    }

    function pushEventToGTag(eventType, eventData) {
        if (typeof window.gtag === 'undefined') {
            // try again in half a second if gtag hasn't been loaded yet.
            setTimeout(function () {
                pushEventToGTag(eventType, eventData);
            }, 500);
        } else {
            RivalIQ.logger.info(`Tracking to GTag: ${eventType}, ${JSON.stringify(eventData)}`);
            window.gtag('event', eventType, eventData);
        }
    }

    function pushEventToIntercom(trackingObject) {

        if (trackingObject && typeof window.Intercom === 'function') {

            RivalIQ.logger.info(`Tracking to Intercom: ${trackingObject.name}`);
            window.Intercom('trackEvent', trackingObject.name);
        }
    }

    function setupAskNicely() {
        if (!window.asknicelySettings || !window.asknicelySettings.show ||
            !window.riqAsknicelyUserConfig || !window.riqAsknicelyUserConfig.email_hash) {
            return;
        }

        function pushToAskNicely() {
            window.asknicelySettings.show(window.riqAsknicelyUserConfig);
        }

        if (window.Intercom) {
            const INTERCOM_UNREAD_WAIT_MS = 5000;
            // We don't want to show askNicely if there's an unread intercom count, so we'll setup a listener
            // for unread count in intercom and wait INTERCOM_UNREAD_WAIT_MS milliseconds. If at any time during
            // that period there's a non-zero unread count, then skip [potentially] showing ask nicely.
            let hadNonZeroUnread = false;
            window.Intercom('onUnreadCountChange', function (unreadCount) {
                if (unreadCount > 0) {
                    hadNonZeroUnread = true;
                }
            });

            setTimeout(function () {
                if (!hadNonZeroUnread) {
                    pushToAskNicely();
                }
            }, INTERCOM_UNREAD_WAIT_MS);
        } else {
            pushToAskNicely();
        }
    }

    // private model used only by tracking
    const AccountEvent = Backbone.Model.extend({
        url: '/api/accountEvent'
    });


    function pushEventToApp(trackingObject, eventOptions) {

        if (pageHasAccountState() && App.state.account.get('id')) {
            const accountEventModel = new AccountEvent();

            accountEventModel.save({
                trackingObject: trackingObject,
                eventOptions: eventOptions
            });
        }
    }

    function pushTrackingEvent(trackingObject, eventOptions) {

        const eventDetails = (eventOptions ? ` - ${JSON.stringify(eventOptions)}` : ``);
        RivalIQ.logger.info(`Tracking: ${trackingObject.name}${eventDetails}`);

        // don't track internal users or when headless
        if (trackingObject && !isInternalUser() && !RivalIQ.isHeadless) {

            pushEventToGTag(trackingObject.name, {
                event_category: trackingObject.module
            });

            if (trackingObject.trackInIntercom || trackInIntercom[trackingObject.name]) {
                pushEventToIntercom(trackingObject);
            }

            pushEventToApp(trackingObject, eventOptions);
        }
    }

    function pushToAuditTrail(id, data) {
        $.post(`/api/users/${RivalIQ.state.user.get('id')}/audit/${id}`, data);
    }

    function trackingUpdate() {
        if (typeof window.Intercom === 'function') {
            window.Intercom('update');
        }
    }

    function openChat() {
        $.post(`/api/users/${RivalIQ.state.user.get('id')}/supportNote`, {
            note: RivalIQ.admin.getBugStateMarkdown()
        });
    }

    // setup up tracking commands
    (function () {

        function createTrackingCommand(handler) {

            return function (name, options) {
                handler((_.isString(name) ? TrackingObject[name] : name), options);
            };
        }

        App.commands.setHandler('tracking:push:dynamic', function (trackingObject) {
            pushTrackingEvent(_.omit(trackingObject, 'options'), trackingObject.options);
        });

        App.commands.setHandler('tracking:update', trackingUpdate);
        App.commands.setHandler('tracking:identify', trackingIdentify);
        App.commands.setHandler('tracking:push', createTrackingCommand(pushTrackingEvent));
        App.commands.setHandler('tracking:push:auth', createTrackingCommand(pushTrackingEvent));
        App.commands.setHandler('tracking:push:audit', pushToAuditTrail);
        App.commands.setHandler('tracking:push:gtag', pushEventToGTag);
        App.commands.setHandler('tracking:openchat', openChat);

        setupAskNicely();
    }());

}, window);
